import React from 'react';
import PropTypes from 'prop-types';

import WaldoficationSimplifiedUpsell from './WaldoficationSimplifiedUpsell';
import withModal from '../modal/withModal';

export const WALDOFICATION_SIMPLIFIED_UPSELL_MODAL =
  'modal/WALDOFICATION_SIMPLIFIED_UPSELL';

const propTypes = {
  actionProps: PropTypes.shape({
    albumId: PropTypes.string,
    albumFolderId: PropTypes.string,
    featureId: PropTypes.string,
    onCheckoutSuccess: PropTypes.func,
  }),
  onRequestClose: PropTypes.func.isRequired,
};

const WaldoficationSimplifiedUpsellModal = ({
  actionProps = {},
  onRequestClose,
}) => {
  const { albumId, albumFolderId, featureId, onCheckoutSuccess } = actionProps;

  return (
    <div className="px-md-4 pb-md-4">
      <WaldoficationSimplifiedUpsell
        albumId={albumId}
        albumFolderId={albumFolderId}
        featureId={featureId}
        onCheckoutSuccess={() => {
          onRequestClose();
          onCheckoutSuccess?.();
        }}
      />
    </div>
  );
};

WaldoficationSimplifiedUpsellModal.propTypes = propTypes;

export default withModal(WaldoficationSimplifiedUpsellModal, {
  name: WALDOFICATION_SIMPLIFIED_UPSELL_MODAL,
  size: 'md',
  type: 'full',
  className: 'waldofication-simplified-upsell-modal',
});
